import React from 'react';
import UploadPageContainer from '../components/Containers/UploadPageContainer';

const ImportAndExportPage = (props) => {
  return (
    <UploadPageContainer
      showUploadCard={props.showUploadCard}
      from={props.from}
      buttonText="Export Data"
    >
    </UploadPageContainer>
  )
}

export default ImportAndExportPage;
